import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import ProductAdditionalInfo from './ProductAdditionalInfo.component';

/** @namespace Advox/Component/ProductAdditionalInfo/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    phone: state.ConfigReducer.phone,
});

/** @namespace Advox/Component/ProductAdditionalInfo/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace Advox/Component/ProductAdditionalInfo/Container */
export class ProductAdditionalInfoContainer extends PureComponent {
    static propTypes = {
        calculatedDeliveryTime: PropTypes.string,
        calculatedDeliveryCost: PropTypes.string,
        showAlternativeDesign: PropTypes.bool,
    };

    static defaultProps = {
        calculatedDeliveryTime: __('No data'),
        calculatedDeliveryCost: '',
        showAlternativeDesign: false,
    };

    state = {
        openedDrawer: null,
    };

    containerFunctions = {
        openDrawer: this.openDrawer.bind(this),
        closeDrawer: this.closeDrawer.bind(this),
    };

    containerProps() {
        const { calculatedDeliveryTime, calculatedDeliveryCost, showAlternativeDesign, phone } = this.props;
        const { openedDrawer } = this.state;

        return {
            calculatedDeliveryTime,
            calculatedDeliveryCost,
            openedDrawer,
            phone,
            showAlternativeDesign,
        };
    }

    openDrawer(type) {
        this.setState({ openedDrawer: type });
    }

    closeDrawer() {
        this.setState({ openedDrawer: null });
    }

    render() {
        return <ProductAdditionalInfo {...this.containerProps()} {...this.containerFunctions} />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductAdditionalInfoContainer);
